import React from 'react'
import style from './style.module.scss'
import useInterfaceLocale from '@aytm/app/swidget/base/modules/locale/useInterfaceLocale.ts'

export interface RedirectViewProps {
  url?: string
  preview: boolean
}

export default function RedirectView({ url, preview }: RedirectViewProps) {
  const { t } = useInterfaceLocale()
  return (
    <div className={style.RedirectView} data-testid="SW-Redirect">
      <p
        data-testid="SW-NavigationPanel-Redirect-Text"
        dangerouslySetInnerHTML={{
          __html: t('preview', 'redirect', preview ? 'text' : 'textSurvey').replace('{url}', url.split('"').join(''))
        }}
      />
    </div>
  )
}
